/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {COLORS} from "@res/colors";
import {elliq_logo, ICONS, new_ir_logo_white} from "@res/icons";
import {
    Route_Admin,
    Route_AdminOrganizations,
    Route_AdminPatients,
    Route_AdminPermission,
    Route_AdminUser,
    Route_CarePlan,
    Route_Dashboard,
    Route_Patients,
    Route_PatientsHome,
    Route_WellnessCoach
} from "../../Routes";
import {margin_tb_med, Spacing} from "@styles/styles";
import {VersionDisplay} from "../../utils/version-display";
import {VGap} from "../widget/VGap";
import {MemoryMonitor} from "../../../widgets/MemoryMonitor";
import {RenderEnv} from "./AppHeader";
import {LeftPanelSection} from "./LeftPanelSection";
import {AlertsPanel} from "./AlertsPanel";
import {CheckinPanel} from "./CheckinPanel";
import {MessagingPanel} from "./MessagingPanel";
import {adminRoles, TabPermissions} from "@app/app-shared/permission";
import {AppPermissions} from "../../utils/Permissions";

export const LeftPanel = () => {

    const renderIRLogo = () => {
        return <div className={"ll_v_c"} style={{flex: 1, maxWidth: 106}}>
            <img alt={"IR logo"} src={new_ir_logo_white} width={80} height={24}/>
        </div>;
    };

    const renderIRIcon = () => {
        return <div className={"ll_v_c"} style={{flex: 1, maxWidth: 106}}>
            <img alt={"ElliQ logo"} src={elliq_logo} height={"100%"}/>
        </div>;
    };

    const renderSeparator = () => {
        return <div style={{height: "1px", backgroundColor: COLORS.white, width: "50px"}}/>;
    };

    const renderFooter = () => {
        return <div className={`ll_v_s ${margin_tb_med}`} style={{alignItems: "center"}}>
            <RenderEnv/>
            {renderMemoryMonitor()}
            {renderIRIcon()}
            <VGap v={Spacing.s}/>
            {renderSeparator()}
            <VGap v={Spacing.s}/>
            {renderIRLogo()}
            <VGap v={Spacing.s}/>
            <VersionDisplay/>
        </div>;
    };

    const renderTabs = () => {
        return <div className={"ll_v_s"}>
            <AppPermissions
                appRoles={[]}
                tabPermissions={[TabPermissions.CLINICAL, TabPermissions.CLINICAL_MESSAGES]}>
                <AlertsPanel/>
            </AppPermissions>
            <AppPermissions
                appRoles={[]}
                tabPermissions={[TabPermissions.CLINICAL, TabPermissions.CLINICAL_MESSAGES]}>
                <CheckinPanel/>
            </AppPermissions>
            <LeftPanelSection icon={ICONS.icon_patient_pressed} routeKeys={[
                Route_PatientsHome,
                Route_Dashboard,
                Route_CarePlan,
                Route_WellnessCoach,
                Route_Patients
            ]} title={"Customers"}/>
            <AppPermissions appRoles={[]} tabPermissions={[TabPermissions.MESSAGES, TabPermissions.CLINICAL_MESSAGES]}>
                <MessagingPanel/>
            </AppPermissions>
            <AppPermissions appRoles={adminRoles}>
                <LeftPanelSection icon={ICONS.icon_patient_pressed} routeKeys={[
                    Route_AdminPatients,
                    Route_AdminUser,
                    Route_AdminPermission,
                    Route_AdminOrganizations,
                    Route_Admin
                ]} title={"Admin"}/>
            </AppPermissions>
        </div>;
    };

    const renderMemoryMonitor = () => <AppPermissions appRoles={adminRoles}>
        <>
            <MemoryMonitor/>
            <VGap v={Spacing.s}/>
        </>
    </AppPermissions>;

    return <div className="ll_v_s" style={{backgroundColor: COLORS.primary_dark_blue, flex: "0 0 106px", justifyContent: "space-between"}}>
        {renderTabs()}
        {renderFooter()}
    </div>;


}
